import { render, staticRenderFns } from "./FlashSaleDemo.vue?vue&type=template&id=19848fd6&scoped=true&"
import script from "./FlashSaleDemo.vue?vue&type=script&lang=ts&"
export * from "./FlashSaleDemo.vue?vue&type=script&lang=ts&"
import style0 from "./FlashSaleDemo.vue?vue&type=style&index=0&id=19848fd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19848fd6",
  null
  
)

export default component.exports